<div class="devops-pipeline-health">
  <section class="devops-card" data-testid="devops-pipeline" aria-labelledby="devops-pipeline-heading">
    <to-section-title
      headingId="devops-pipeline-heading"
      [title]="'liveDashboard.devops.pipeline.title' | translate"
      [subtitle]="'liveDashboard.devops.pipeline.subtitle' | translate"
    />
    <div class="devops-card__services">
      @for (service of services; track service.service) {
        <div class="deployment-service" data-testid="deployment-service">
          <div class="deployment-service__head">
            <i class="deployment-service__provider fa-brands fa-github" aria-hidden="true"></i>
            <span class="deployment-service__name" data-testid="deployment-service-name">{{ service.service }}</span>
            <code class="deployment-service__branch" data-testid="deployment-branch">{{ service.branch }}</code>
          </div>
          <div class="deployment-service__stages">
            @for (stage of service.stages; track stage.name; let last = $last) {
              <app-deployment-stage-card class="deployment-service__stage" [stage]="stage" />
              @if (!last) {
                <span class="deployment-service__chevron" data-testid="deployment-chevron" aria-hidden="true">
                  <mat-icon>chevron_right</mat-icon>
                </span>
              }
            }
          </div>
        </div>
      }
    </div>
  </section>

  <section class="devops-card" data-testid="service-health" aria-labelledby="service-health-heading">
    <to-section-title
      headingId="service-health-heading"
      [title]="'liveDashboard.devops.health.title' | translate"
      [subtitle]="'liveDashboard.devops.health.subtitle' | translate"
    />
    <div class="devops-card__health">
      @for (service of health; track service.label) {
        <app-service-health-row [service]="service" />
      }
    </div>
  </section>
</div>
